import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { catchError, map, of } from "rxjs";
import { CurrentStateService } from "../services/current-state.service";

export const regularViewGuard: CanActivateFn = () => {
	const router = inject(Router);
	const state = inject(CurrentStateService);

	return state.getCurrentState().pipe(
		map((state) => {
			if (state.school.zfInternalViewSchool === "YES") {
				return router.createUrlTree(["internal-views"]);
			} else if (state.school.subscriptionDTO?.allowAccess) {
				// Check if school subscription is active before allowing navigation to proceed otherwise redirect to subscription page below
				return true;
			}
			// The school subscription has expired, redirect to subscription expired page to show proforma invoice
			return router.createUrlTree(["subscription"]);
		}),
		// Without this the guard's observable errors, Angular cancels the navigation, and the app is
		// left on its loading state with nothing to recover it - the reported "freezes on login, have
		// to reload". Send the user somewhere actionable instead.
		catchError(() => of(router.createUrlTree(["/auth/login"]))),
	);
};
